export function get(object, accessorFn, defaultValue) {
    try {
        var result = accessorFn(object);
        return result === undefined || result === null ? defaultValue : result;
    }
    catch (e) {
        return defaultValue;
    }
}
export default get;
//# sourceMappingURL=index.js.map